export const blockIconsHardwareDesktopWindows = (
	<span className='material-symbols-outlined'>desktop_windows</span>
);
